import { StyleSheet } from "react-native";

const style = StyleSheet.create({
  spinner: {
    paddingVertical: 100,
  },
});

export { style };
